import React from 'react';
import { HStack, Text, Box, Icon } from '@chakra-ui/react';
import { DiceDictionary } from '../Contexts/ConstantsCollection.js';
import { useAction } from '../Contexts/CharacterActions.js';

const GearDamageText = ({ gearItem }) => {
  const { getDiceIcon } = useAction();

  return (
    <HStack w="100%" align="center" justify="center" justifyContent="center">
      <Box position="relative" display="inline-block"></Box>
      <Text display="inline-flex" alignItems="center" margin="-1">
        {getDiceIcon(gearItem.trait.name, {
          style: {
            strokeWidth: '1',
            fontSize: '2rem',
          },
        })}
      </Text>
      {gearItem.additionalDamage.map(([count, die], i) => (
        <Text
          key={i}
          display="inline-flex"
          alignItems="center"
          fontSize="20"
          margin="-1"
        >
          +{count}
          <Icon as={DiceDictionary[die][1]} boxSize={5} />
        </Text>
      ))}
      {gearItem.bonus > 0 && (
        <Text fontSize="20" fontWeight="semibold" color="green">
          +{gearItem.bonus}
        </Text>
      )}
    </HStack>
  );
};

export default GearDamageText;
